import axios from "../../http";

import {
  INSTAGRAM_VIDEO_LIST_REQUEST,
  INSTAGRAM_VIDEO_LIST_SUCCESS,
  INSTAGRAM_VIDEO_LIST_FAIL,
} from "../Constants/InstagramVideoConstants";

export const listStoreInstagramVideos =
  () => async (dispatch) => {
    try {
      dispatch({
        type: INSTAGRAM_VIDEO_LIST_REQUEST,
      });

      const { data } = await axios.get(
        "/api/instagram-videos/store",
        {
          params: {
            t: Date.now(),
          },
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        }
      );

      const normalizedVideos =
        Array.isArray(data)
          ? data
          : Array.isArray(data?.videos)
          ? data.videos
          : [];

      dispatch({
        type: INSTAGRAM_VIDEO_LIST_SUCCESS,
        payload: normalizedVideos,
      });
    } catch (error) {
      dispatch({
        type: INSTAGRAM_VIDEO_LIST_FAIL,
        payload:
          error.response?.data?.message ||
          error.message,
      });
    }
  };